export type DomainRow = {
  domain: string;
  binPrice?: number;
  offer?: boolean;
  rto?: boolean;
  bundle?: string | null;
  tld?: string | null;
  tags?: string | string[] | null;
  length?: number | null;
  updated_at?: string | null;
};

export function norm(s?: string | null) {
  return (s ?? '').toLowerCase().trim();
}

// Keep newest if duplicates; compare updated_at lexicographically as ISO
export function dedupeByDomain(rows: DomainRow[]): DomainRow[] {
  const m = new Map<string, DomainRow>();
  for (const r of rows ?? []) {
    const k = norm(r.domain);
    if (!k) continue;
    const prev = m.get(k);
    if (!prev) {
      m.set(k, r);
      continue;
    }
    const pa = String(prev.updated_at ?? '');
    const rb = String(r.updated_at ?? '');
    if (rb > pa) m.set(k, r);
  }
  return Array.from(m.values());
}
